export default __webpack_public_path__ + "static/media/40.e456f176.svg";